import { render, staticRenderFns } from "./profile-rank.vue?vue&type=template&id=4a48a25c&"
import script from "./profile-rank.vue?vue&type=script&lang=js&"
export * from "./profile-rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports